export var TypeServer;
(function (TypeServer) {
    TypeServer[TypeServer["Localhost"] = 1] = "Localhost";
    TypeServer[TypeServer["NotLocalhost"] = 2] = "NotLocalhost";
})(TypeServer || (TypeServer = {}));
export const SERVER = {
    type: TypeServer.Localhost,
};
